module.exports = __webpack_public_path__ + "static/media/logo-aspecir-negativo.f3ab758c.png";